import $ from 'jquery';

const externalLinkCall = (linkTarget) => {
    let targetRemove = linkTarget.split('/', 1);

    let targetRemoveMore = linkTarget.replace(targetRemove + '//', '');

    let targetLabel = targetRemoveMore.split('/')[0];

    if (linkTarget.includes('//www')) {

        targetRemove = linkTarget.split('.', 1);
        targetRemoveMore = linkTarget.replace(targetRemove + '.', '');
        targetLabel = targetRemoveMore.split('/')[0];

    }


    const modal = document.getElementById('ume-link-modal');
    const modalBody = modal.querySelector('.modal-body');
    modalBody.innerHTML = '';
    modalBody.classList.add('bg-uke-blue', 'text-font-light');
    const warningHolder = document.createElement('div');
    warningHolder.classList.add('d-flex', 'flex-column', 'justify-content-center', 'align-items-center', 'text-center', 'text-font-light');
    const messageHeading = document.createElement('h4');
    messageHeading.classList.add('text-font-light');
    messageHeading.innerHTML = 'Sie verlassen jetzt die Webseite des UME- Nachhaltigkeitsmanagements.';
    warningHolder.append(messageHeading);
    const info = document.createElement('p');
    info.innerHTML = `Externes Ziel: ${targetLabel}`;
    warningHolder.append(info);
    const button = document.createElement('a');
    button.classList.add('btn', 'btn-outline-font-light', 'ume-external-link-confirm');
    button.innerHTML = 'Okay, weiter';
    button.href = linkTarget;
    button.setAttribute('target', '_blank');
    button.setAttribute('rel', 'noopener noreferrer');
    warningHolder.append(button);
    modalBody.append(warningHolder);

    $('#ume-link-modal').modal('show')
    document.addEventListener('click', ev => {
        if (!ev.target.matches('.ume-external-link-confirm')) return;
        $('#ume-link-modal').modal('hide');
    }, true)

}
export default externalLinkCall;